import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import './picture.scss';

// Style variation for tertiary picture is TBD

export const PictureComponent = ({ id, src, alt, variant, ...rest }) => (
  // TODO: Create a class and modifier(s) for nmx-picture in nmx-template. This is currently unsupported.
  <picture
    id={id}
    className={classnames('nmx-picture', `nmx-picture--${variant}`)}
    {...rest}>
    <img className='nmx-picture__image' src={src} alt={alt} />
  </picture>
);

PictureComponent.propTypes = {
  variant: PropTypes.oneOf(['primary', 'secondary']).isRequired,
  id: PropTypes.string,
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
};

PictureComponent.defaultProps = { variant: 'primary' };

export default PictureComponent;
